import React, { Component } from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import moment from 'moment-timezone'
import { translate } from "react-i18next"

import './RescheduleScreen.css'

import cancelAppointmentMutation from 'graphql/mutations/cancelAppointment'

class RescheduleScreen extends Component {
  constructor(props){
    super(props)

    this.state = {
      animation: '',
      loading: false
    }

    this.cancelAppointment = this.cancelAppointment.bind(this)
    this.onReschedule = this.onReschedule.bind(this)
  }

  onReschedule({ rescheduleFutureOccurrences }){
    this.setState({ animation: 'leaving' }, () => {
      setTimeout(() => {
        this.props.onReschedule({ rescheduleFutureOccurrences })
      }, 250)
    })
  }

  cancelAppointment({ cancelFutureOccurrences }){
    this.setState({ loading: true })
    const occurrenceDate = (!this.props.appointment.originalDate || new Date(this.props.appointment.originalDate).getTime() === 0) ? this.props.appointment.date : this.props.appointment.originalDate
    this.props.mutate({
      variables: {
        id: this.props.appointment.id,
        token: this.props.token,
        cancelFutureOccurrences,
        occurrenceDate,
      }
    }).then((response) => {
      if(response.data && response.data.cancelAppointment && response.data.cancelAppointment.id) {
        this.setState({ animation: 'leaving' })
        setTimeout(this.props.onCancel, 250)
      }
    }).catch((reason) => {
      console.log(reason)
      alert("An error occurred when trying to cancel your appointment")
    })
  }

  getThemedRescheduleScreen() {
    return styled.div`
      .btn-primary {
        background: ${props => props.theme.main};
        border-color: ${props => props.theme.main};
        &:hover {
          background: ${props => props.theme.hover};
          border-color: ${props => props.theme.hover};
        }
      }
    `
  }

  renderCantReschedule(reason) {
    const ThemedRescheduleScreen = this.getThemedRescheduleScreen()
    const { appointment, business, t } = this.props

    return (
      <ThemedRescheduleScreen className={`reschedule-overlay ${this.state.animation}`}>
        <div className="inner">
          <h1>{ t('greeting', { name: appointment.customer.name }) }</h1>
          <p>{ t('appointment-found', { date: moment(appointment.date).format(business.dateFormat.date), time: moment(appointment.date).format(business.dateFormat.time) }) }</p>
          <p className="alert">{ reason }</p>
        </div>
      </ThemedRescheduleScreen>
    )
  }

  canReschedule(appointment, service) {
    if (!service) {
      return false
    }

    if (service.leadTime && moment(appointment.date).subtract(service.leadTime, 'minutes').toISOString() <= new Date().toISOString()) {
      return false
    }

    return true
  }

  canCancel(appointment, service) {
    if (!service) {
      return false
    }

    const cancelLeadTime = service.cancelLeadTime === undefined || service.cancelLeadTime === null ? service.leadTime : service.cancelLeadTime
    if (cancelLeadTime && moment(appointment.date).subtract(cancelLeadTime, 'minutes').toISOString() <= new Date().toISOString()) {
      return false
    }

    return true
  }

  renderRescheduleButtons() {
    const { appointment, t } = this.props
    const service = this.props.business.services.find(s => s.id === appointment.service.id)

    if (!this.canReschedule(appointment, service)) {
      return <p className="alert">This appointment can no longer be rescheduled as there is insufficient notice time.</p>
    }

    return (
      <div>
        <button onClick={() => { this.onReschedule({ rescheduleFutureOccurrences: false }) }} disabled={this.state.loading} className="btn btn-primary">{ t('reschedule') }</button>
        { appointment.hasMoreOccurrences && <button onClick={() => { this.onReschedule({ rescheduleFutureOccurrences: true }) }} disabled={this.state.loading} className="btn btn-primary">{ t('reschedule-all-future-occurrences') }</button> }
      </div>
    )
  }

  renderCancelButtons() {
    const { appointment, t } = this.props
    const service = this.props.business.services.find(s => s.id === appointment.service.id)

    if (!this.canCancel(appointment, service)) {
      return <p className="alert">This appointment can no longer be cancelled as there is insufficient notice time.</p>
    }

    return (
      <div>
        <button onClick={() => this.cancelAppointment({ cancelFutureOccurrences: false })} disabled={this.state.loading} className="btn btn-danger">{ t('cancel-appointment') }</button>
        { appointment.hasMoreOccurrences && <button onClick={() => this.cancelAppointment({ cancelFutureOccurrences: true })} disabled={this.state.loading} className="btn btn-danger">{ t('cancel-all-future-occurrences') }</button> }
      </div>
    )
  }

  render() {
    const { appointment, business, t } = this.props
    const service = this.props.business.services.find(s => s.id === appointment.service.id)
    const ThemedRescheduleScreen = this.getThemedRescheduleScreen()

    const isPast = appointment.date <= new Date().toISOString()
    if (isPast) {
      return this.renderCantReschedule("This is a past appointment and can no longer be rescheduled or cancelled.")
    }

    if (!this.canReschedule(appointment, service) && !this.canCancel(appointment, service)) {
      return this.renderCantReschedule("This appointment can no longer be rescheduled or cancelled as there is insufficient notice time.")
    }

    return (
      <ThemedRescheduleScreen className={`reschedule-overlay ${this.state.animation}`}>
        <div className="inner">
          <h1>{ t('greeting', { name: appointment.customer.name }) }</h1>
          <p>{ t('appointment-found', { date: moment(appointment.date).format(business.dateFormat.date), time: moment(appointment.date).format(business.dateFormat.time) }) }</p>
          <p>{ t('what-to-do') }</p>
          <div className="actions">
            { this.renderRescheduleButtons() }
            { this.renderCancelButtons() }
          </div>
        </div>
      </ThemedRescheduleScreen>
    );
  }
}

export default graphql(cancelAppointmentMutation)(translate("translations")(RescheduleScreen))
